import React from 'react';

// styles
import './ycTyping.scss';

export class YcTyping extends React.PureComponent {
  words = ['Words'];
  indexWord = 0;
  indexChar = 0;
  speedNextWord = 1000;
  speedNextChar = 150;
  timeout = null;
  state = {
    word: '',
  };

  constructor(props) {
    super();
    this.words = props.words || this.words;
  }

  componentDidMount() {
    this.selectWord(0);
  }

  nextWord() {
    this.indexWord++;
    if (this.indexWord >= this.words.length) {
      this.indexWord = 0;
    }
    this.indexChar = -1;
    this.timeout = setTimeout(() => {
      this.nextCharWord();
    }, this.speedNextWord);
  }

  nextCharWord() {
    const word = this.words[this.indexWord];
    this.indexChar++;
    this.timeout = setTimeout(() => {
      this.setState({
        word: word.slice(0, this.indexChar),
      });
      if (this.indexChar < word.length) {
        this.nextCharWord();
      } else {
        this.nextWord();
      }
    }, this.speedNextChar);
  }

  selectWord(index) {
    this.indexWord = index;
    this.indexChar = 0;
    this.setState({ word: '' });
    this.nextCharWord();
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    return (
      <span className="typing">
        {this.state.word}
        <span className="pipe">|</span>
      </span>
    );
  }
}
